// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-6VFA","delete":"styles_delete__2h6vf","update":"styles_update__2EHTF","add":"styles_add__nKZf0"};